import { render, staticRenderFns } from "./ComprobacionesAMEX.vue?vue&type=template&id=3f22dbad&"
import script from "./ComprobacionesAMEX.vue?vue&type=script&lang=js&"
export * from "./ComprobacionesAMEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ComprobacionesAMEX.vue"
export default component.exports